<script >
import {getCurrentInstance, ref} from 'vue';

export default {
  components: {},
  props: {
    width: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    position: {
      default: {
        top: 0,
        left: 0,
      },
      type: Object,
    },
    model: {
      default: {optionsCopy: 1, rowCount: 0, numberRow: 1, rowIndex: 0},
      type: Object,
    },
    timer: {
      defaut: {
        timeout: 0,
      },
      type: Object,
    },
  },

  setup(props) {
    const {proxy} = getCurrentInstance();

    const option = ref(props.model.optionsCopy);

    const handlerMouseEnter = () => {
      clearTimeout(props.timer.timeout);
    };


    return {
      props,
      option,
      handlerMouseEnter
    };
  },
};

</script>

<template>
  <div class="msg-box msg-box-context-menu" ref="root">
    <div
      v-click-away="
        e => {
          $close(this, Object.assign(model, {answer: false}));
        }
      "
      @mouseenter="handlerMouseEnter"
      ref="msg"
      class="msg-center"
      :style="{width: width + 'px', left: position.left + 'px', top: position.top + 'px'}"
    >
      <div class="msg-title">
        {{ title }}
      </div>
      <div class="msg-message flex-column mt-2">
        <div class="flex-row align-center">
          <ms-radio
            label="Lên trên"
            v-model="option"
            :key-value="1"
            @ms-change="props.model.optionsCopy = 1"
          />
          <ms-radio
            label="Xuống dưới"
            class="ml-2"
            v-model="option"
            :key-value="2"
            @ms-change="props.model.optionsCopy = 2"
          />
          <ms-number
            spin
            class="ml-2 w-80"
            :disabled="option == 3"
            :min="0"
            v-model="props.model.rowCount"
          />
          <span class="ml-1">Dòng</span>
        </div>
        <div class="flex-row align-center mt-1">
          <ms-radio 
            label="Tất cả các dòng"
            v-model="option"
            :key-value="3"
            @ms-change="props.model.optionsCopy = 3"
          />
        </div>
      </div>
      <div class="msg-buttons flex-end">
        <button class="msg-btn btn secondary-outline " @click="$close(this, Object.assign(model, {answer: false}))">
          {{ $t('i18nComponent.MessageBox.Cancel') }}
        </button>

        <button class="msg-btn btn primary ml-1 mr-0" @click="$close(this, Object.assign(model, {answer: true}))">
          {{ $t('i18nComponent.MessageBox.Accept') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/scss/components/MsMessageBox.scss';
.msg-box {
  background: unset !important;
  .msg-center {
    transform: unset;
    .msg-message{
      padding-left: 3px;
      display: flex;
      height: 60px;
    }
  }
}
.w-80 {
  width: 80px;
}
.align-center {
  align-items: center;
}
</style>
